<script setup>
import { computed } from 'vue'
import { Button, Input, Label, Select } from '@components'

import { useSettings } from '@store/settings'
const $settings = useSettings()

const site = prebook_admin.site

const countries = prebook_admin.options.countries.map((country) => {
    return {
        label: country.name,
        value: country.code,
    }
})


const phoneCode = computed(() => {
    const country = prebook_admin.options.countries.find((country) => country.code == $settings.business.country)
    return country ? '+' + country.phone : ''
})
</script>

<template>
    <div class="flex flex-col items-center gap-5">
        <div class="w-full">
            <Label>Street Address</Label>
            <Input v-model="$settings.business.street" type="text" class="my-1.5"></Input>
        </div>

        <div class="grid w-full grid-cols-1 gap-5 md:grid-cols-2">
            <div class="w-full">
                <Label>City</Label>
                <Input v-model="$settings.business.city" type="text" class="my-1.5"></Input>
            </div>
            <div class="w-full">
                <Label>State/Province</Label>
                <Input v-model="$settings.business.state" type="text" class="my-1.5"></Input>
            </div>
            <div class="w-full">
                <Label>Postal/Zip code</Label>
                <Input v-model="$settings.business.zip_code" type="number" class="my-1.5"></Input>
            </div>
            <div class="w-full">
                <Label>Country</Label>
                <Select :options="countries" v-model="$settings.business.country" :search="true" selectionContainer="py-[10px]" class="my-1.5"></Select>
            </div>
        </div>

        <div class="w-full">
            <Label>Phone</Label>
            <Input type="text" title="Please enter only numbers" v-model="$settings.business.phone" :placeholder="phoneCode" class="my-1.5"></Input>
        </div>
        <div class="w-full">
            <Label>Website</Label>
            <Input type="url" v-model="$settings.business.website" title="Include http:// or https:// in the URL" class="my-1.5" placeholder="https://"></Input>
            <Button type="secondary_color" v-if="!$settings.business.website" @click="$settings.business.website = site.url">Use {{ site.url }}</Button>
        </div>
        <div class="w-full">
            <Label>Email <div class="text-[#D92D20] inline-block">*</div></Label>
            <Input type="email" class="my-1.5" v-model="$settings.business.email" placeholder="your@business.com"></Input>
            <Button type="secondary_color" v-if="!$settings.business.email" @click="$settings.business.email = site.admin_email">Use {{ site.admin_email }}</Button>
        </div>
    </div>
</template>



<style>

</style>